import { render, staticRenderFns } from "./all.vue?vue&type=template&id=64afe239&scoped=true&"
import script from "./all.vue?vue&type=script&lang=ts&"
export * from "./all.vue?vue&type=script&lang=ts&"
import style0 from "./all.vue?vue&type=style&index=0&id=64afe239&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64afe239",
  null
  
)

export default component.exports